// all const are given in values of "px"
export const breakpoints = {
  small: 640,
  medium: 768,
  large: 1024,
  xlarge: 1279,
  xxlarge: 1441,
  xxxlarge: 1641,
  imac_retina: 2559,
  all_screen_sizes: 1e8,
}

export const aboutUsBreakPoint = 850

export const adGalleryBreakPoint_Fr = 999

export const afWayChallengeBlockBreakPoint_Fr = 1099

export const adPageTemplateLpBreakPoint = 1200

export const adTemplateLpBreakPoint = 899

export const aiLpBreakPoint = 999

export const blogBreakPoint = 999

export const bookADemoLpBreakPoint = 1199

export const careersLpBreakPoint = 999

export const competitorLpBreakPoint = 860

export const conciergeMigrationLpBreakPoint = 1199

export const ctaInlineBreakPoint = 899

export const ctaMainBreakPoint = 899

export const ctaMainInsightsBreakPoint = 930

export const ctaSplitBreakPoint = 899

export const emptySpaceWidthBreakPoint = 1200

export const glossaryBreakPoint = 999

export const glossaryAlphabetBreakPoint = 899

export const headerBreakPoint = 999
export const headerWithSearchBreakPoint = 1099

export const homepageFeaturesGalleryBreakPoint = 999
export const homepageFeaturesGalleryBreakPoint_Fr_De = 9999

// chosen that all (standard) content fields fit in 4 lines
export const imageGalleryBreakPoint = 1023

export const integrationsBlockBreakPoint = 785

export const learnShowCardsNavigationBreakPoint = 1024

export const longCopyBreakPoint = 1023

export const longCopyMobileBreakPoint = 768

export const pricingCtaBreakPoint = 1005

export const pricingPlansBreakPoint = 999

export const referralDemoBreakPoint = 999

// width when the slider card logic switches from hover to clicking (to flip card)
export const sliderCardClickHoverSwitchBreakPoint = 999

// used for templates category lp and downloadable templates lp
export const templatesLpBreakPoint = 1023

// used for templates category lp
export const templatesBlockBreakPoint = 950
export const templatesHeaderBreakPoint = 950

export const tikTokBreakPoint = 430

// chosen that all (standard) descriptions still fit in 2 lines
export const videoGalleryBreakPoint = 945
export const videoGalleryAirfocusWayBreakPoint = 1023
